import React, { useEffect, useState } from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';
import { hashHistory } from 'react-router';
import { Async } from 'weborder/Data';

import { PaymentMethodList } from '../../../pages/PaymentMethods/components/PaymentMethodList';
import { handleDelete } from '../../../pages/PaymentMethods/utils/PaymentMethodsUtils';
import { Track } from '../../../weborder/analytics';
import { AppConfig, Customer } from '../../../weborder/Api';
import { paymentSelectors } from '../../../weborder/selectors';
import { domUtils } from '../../../weborder/utils';
import { Snackbar, Typography } from '../../atoms';
import { Dialog } from '../../molecules';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiPaper-root': {
      minHeight: theme.spacing(55),
    },
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  valid: {
    color: theme.palette.success.main,
  },
  wideSpacing: {
    wordSpacing: theme.spacing(1),
  },
}));

export type Props = {
  appConfig: Async<AppConfig>;
  customer: Async<Customer>;
  handlePaymentRemoved: (p: { paymentId: string }) => void;
  params: any;
  payments: ReturnType<typeof paymentSelectors.getAvailablePayments>;
  translate: ReturnType<typeof getTranslate>;
};

const PaymentMethodsDialog = (props: Props): JSX.Element => {
  const {
    appConfig,
    customer,
    handlePaymentRemoved,
    params,
    payments,
    translate,
  } = props;

  const [error, setError] = useState('');
  useEffect(() => {
    domUtils.skipToContent();
  }, []);

  const classes = useStyles({});

  const handleOnBackLink = (params) => {
    hashHistory.push(`/restaurant/${params.vrid}/${params.type}/${params.id}`);
  };

  const onDelete = (paymentAccountId: number) => {
    const errorMessage = handleDelete(
      appConfig,
      customer,
      paymentAccountId,
      translate,
    );
    if (errorMessage) {
      setError(errorMessage);
    } else {
      handlePaymentRemoved({ paymentId: `${paymentAccountId}` });
      Track('Payments', 'Remove Card');
    }
  };

  return (
    <Dialog
      className={classes.root}
      onTitleClick={() => handleOnBackLink(params)}
      open={true}
    >
      <header>
        <Typography className={classes.title} variant="h1">
          {translate('Payment_methods_title')}
        </Typography>
      </header>

      <article>
        <PaymentMethodList
          handleDelete={onDelete}
          payments={payments}
          translate={translate}
        />

        {!!error && <Snackbar message={error} severity="error" />}
      </article>
    </Dialog>
  );
};

export { PaymentMethodsDialog };
